import { DefaultPending } from '@sportybot-web/components/default-pending';
import { createRouter } from '@tanstack/react-router';

import { ErrorAlert } from './components/alerts/error';
import { routeTree } from './routeTree.gen';

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

export const router = createRouter({
  // These will be set via when bootstrapping the app by injecting context
  /* eslint-disable @typescript-eslint/no-non-null-assertion */
  context: {
    authClient: undefined!,
    queryClient: undefined!,
    sportySdk: undefined!,
    user: undefined!,
  },
  /* eslint-enable @typescript-eslint/no-non-null-assertion */
  defaultErrorComponent: ErrorAlert,
  defaultPendingComponent: DefaultPending,
  defaultStructuralSharing: true,
  routeTree,
  scrollRestoration: true,
  scrollToTopSelectors: ['[data-app-scroll]'],
});
